import { render, staticRenderFns } from "./About-web.vue?vue&type=template&id=72bfb592&scoped=true"
import script from "./About-web.vue?vue&type=script&lang=js"
export * from "./About-web.vue?vue&type=script&lang=js"
import style0 from "./About-web.vue?vue&type=style&index=0&id=72bfb592&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bfb592",
  null
  
)

export default component.exports